import React from 'react';

// `icon` and `badge` are still accepted for compatibility but intentionally not rendered.
// eslint-disable-next-line no-unused-vars
const PageHeader = ({ icon, badge, title, description, children, className = '' }) => (
  <header className={`overflow-hidden rounded-2xl border border-zinc-200/80 bg-white shadow-sm mb-6 ${className}`}>
    <div aria-hidden="true" className="flex h-1 shrink-0">
      <span className="flex-1 bg-zinc-950" />
      <span className="flex-1 bg-[#DD0000]" />
      <span className="flex-1 bg-[#FFCE00]" />
    </div>
    <div className="px-5 py-5 sm:px-7 sm:py-6">
      <h1 className="text-2xl font-extrabold tracking-tight text-zinc-900 sm:text-[28px]">{title}</h1>
      {description && (
        <p className="mt-1.5 text-sm leading-relaxed text-zinc-500">{description}</p>
      )}
      {children && <div className="mt-4 border-t border-zinc-100 pt-4">{children}</div>}
    </div>
  </header>
);

export default PageHeader;
